module.exports = __webpack_public_path__ + "img/fabricacion_msh.84374f01.jpg";